import VNode from './VNode';
import { generate } from './instanceId';
var AppContainer = /** @class */ (function () {
    function AppContainer() {
        this.updateQueue = [];
        this.root = new VNode({
            id: generate(),
            type: 'root',
            container: this,
        });
        this.root.mounted = true;
    }
    AppContainer.prototype.requestUpdate = function (path, start, deleteCount) {
        var items = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            items[_i - 3] = arguments[_i];
        }
        // ignore
    };
    AppContainer.prototype.applyUpdate = function () {
        this.context._pages.forEach(function (page) {
            page.container.applyUpdate();
            page.modalContainer.applyUpdate();
        });
    };
    AppContainer.prototype.createCallback = function (name, fn) {
        this.context[name] = fn;
    };
    AppContainer.prototype.appendChild = function (child) {
        this.root.appendChild(child);
    };
    AppContainer.prototype.removeChild = function (child) {
        this.root.removeChild(child);
    };
    AppContainer.prototype.insertBefore = function (child, beforeChild) {
        this.root.insertBefore(child, beforeChild);
    };
    return AppContainer;
}());
export default AppContainer;
